export default "__VITE_ASSET__BTQMj8D5__"